function cov_1bf3wwzwf() {
  var path = "/app/src/components/icon/icon.tsx";
  var hash = "39b9ba5c708b03e4c77fdd3777db7b51c9129460";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/icon/icon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 16
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 29
        },
        end: {
          line: 9,
          column: 43
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "3": {
        start: {
          line: 13,
          column: 14
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "4": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 49
        }
      },
      "5": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 15,
          column: 47
        }
      },
      "6": {
        start: {
          line: 16,
          column: 30
        },
        end: {
          line: 16,
          column: 63
        }
      },
      "7": {
        start: {
          line: 17,
          column: 25
        },
        end: {
          line: 17,
          column: 55
        }
      },
      "8": {
        start: {
          line: 18,
          column: 34
        },
        end: {
          line: 18,
          column: 71
        }
      },
      "9": {
        start: {
          line: 19,
          column: 29
        },
        end: {
          line: 19,
          column: 63
        }
      },
      "10": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 20,
          column: 53
        }
      },
      "11": {
        start: {
          line: 21,
          column: 25
        },
        end: {
          line: 21,
          column: 55
        }
      },
      "12": {
        start: {
          line: 22,
          column: 23
        },
        end: {
          line: 22,
          column: 51
        }
      },
      "13": {
        start: {
          line: 23,
          column: 24
        },
        end: {
          line: 23,
          column: 53
        }
      },
      "14": {
        start: {
          line: 24,
          column: 22
        },
        end: {
          line: 24,
          column: 49
        }
      },
      "15": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 49
        }
      },
      "16": {
        start: {
          line: 26,
          column: 28
        },
        end: {
          line: 26,
          column: 61
        }
      },
      "17": {
        start: {
          line: 27,
          column: 27
        },
        end: {
          line: 27,
          column: 59
        }
      },
      "18": {
        start: {
          line: 28,
          column: 27
        },
        end: {
          line: 28,
          column: 59
        }
      },
      "19": {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 29,
          column: 49
        }
      },
      "20": {
        start: {
          line: 30,
          column: 23
        },
        end: {
          line: 30,
          column: 51
        }
      },
      "21": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "22": {
        start: {
          line: 41,
          column: 24
        },
        end: {
          line: 41,
          column: 35
        }
      },
      "23": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 47,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 16
          },
          end: {
            line: 4,
            column: 17
          }
        },
        loc: {
          start: {
            line: 8,
            column: 5
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 17
          }
        },
        loc: {
          start: {
            line: 14,
            column: 22
          },
          end: {
            line: 14,
            column: 49
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 15
          },
          end: {
            line: 15,
            column: 16
          }
        },
        loc: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 16,
            column: 24
          },
          end: {
            line: 16,
            column: 25
          }
        },
        loc: {
          start: {
            line: 16,
            column: 30
          },
          end: {
            line: 16,
            column: 63
          }
        },
        line: 16
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 17,
            column: 19
          },
          end: {
            line: 17,
            column: 20
          }
        },
        loc: {
          start: {
            line: 17,
            column: 25
          },
          end: {
            line: 17,
            column: 55
          }
        },
        line: 17
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 18,
            column: 28
          },
          end: {
            line: 18,
            column: 29
          }
        },
        loc: {
          start: {
            line: 18,
            column: 34
          },
          end: {
            line: 18,
            column: 71
          }
        },
        line: 18
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 24
          }
        },
        loc: {
          start: {
            line: 19,
            column: 29
          },
          end: {
            line: 19,
            column: 63
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 20,
            column: 18
          },
          end: {
            line: 20,
            column: 19
          }
        },
        loc: {
          start: {
            line: 20,
            column: 24
          },
          end: {
            line: 20,
            column: 53
          }
        },
        line: 20
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 20
          }
        },
        loc: {
          start: {
            line: 21,
            column: 25
          },
          end: {
            line: 21,
            column: 55
          }
        },
        line: 21
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 22,
            column: 17
          },
          end: {
            line: 22,
            column: 18
          }
        },
        loc: {
          start: {
            line: 22,
            column: 23
          },
          end: {
            line: 22,
            column: 51
          }
        },
        line: 22
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 23,
            column: 18
          },
          end: {
            line: 23,
            column: 19
          }
        },
        loc: {
          start: {
            line: 23,
            column: 24
          },
          end: {
            line: 23,
            column: 53
          }
        },
        line: 23
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 24,
            column: 16
          },
          end: {
            line: 24,
            column: 17
          }
        },
        loc: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 49
          }
        },
        line: 24
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 25,
            column: 16
          },
          end: {
            line: 25,
            column: 17
          }
        },
        loc: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 25,
            column: 49
          }
        },
        line: 25
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 26,
            column: 22
          },
          end: {
            line: 26,
            column: 23
          }
        },
        loc: {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 61
          }
        },
        line: 26
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 27,
            column: 21
          },
          end: {
            line: 27,
            column: 22
          }
        },
        loc: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 27,
            column: 59
          }
        },
        line: 27
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 28,
            column: 21
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 27
          },
          end: {
            line: 28,
            column: 59
          }
        },
        line: 28
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 29,
            column: 16
          },
          end: {
            line: 29,
            column: 17
          }
        },
        loc: {
          start: {
            line: 29,
            column: 22
          },
          end: {
            line: 29,
            column: 49
          }
        },
        line: 29
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 18
          }
        },
        loc: {
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 30,
            column: 51
          }
        },
        line: 30
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 40,
            column: 21
          }
        },
        loc: {
          start: {
            line: 40,
            column: 60
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 40
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39b9ba5c708b03e4c77fdd3777db7b51c9129460"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bf3wwzwf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bf3wwzwf();
import React, { Suspense } from 'react';
import { lazily } from 'react-lazily';
cov_1bf3wwzwf().s[0]++;
var dynamic = function dynamic(loader) {
  cov_1bf3wwzwf().f[0]++;
  var _ref = (cov_1bf3wwzwf().s[1]++, lazily(loader)),
    ReactComponent = _ref.ReactComponent;
  cov_1bf3wwzwf().s[2]++;
  return ReactComponent;
};
var ICONS = (cov_1bf3wwzwf().s[3]++, {
  info: dynamic(function () {
    cov_1bf3wwzwf().f[1]++;
    cov_1bf3wwzwf().s[4]++;
    return import('./assets/info.svg');
  }),
  bag: dynamic(function () {
    cov_1bf3wwzwf().f[2]++;
    cov_1bf3wwzwf().s[5]++;
    return import('./assets/bag.svg');
  }),
  'tabby-care': dynamic(function () {
    cov_1bf3wwzwf().f[3]++;
    cov_1bf3wwzwf().s[6]++;
    return import('./assets/tabby-care.svg');
  }),
  shariat: dynamic(function () {
    cov_1bf3wwzwf().f[4]++;
    cov_1bf3wwzwf().s[7]++;
    return import('./assets/shariat.svg');
  }),
  'shariat-modern': dynamic(function () {
    cov_1bf3wwzwf().f[5]++;
    cov_1bf3wwzwf().s[8]++;
    return import('./assets/shariat-modern.svg');
  }),
  percentages: dynamic(function () {
    cov_1bf3wwzwf().f[6]++;
    cov_1bf3wwzwf().s[9]++;
    return import('./assets/percentages.svg');
  }),
  people: dynamic(function () {
    cov_1bf3wwzwf().f[7]++;
    cov_1bf3wwzwf().s[10]++;
    return import('./assets/people.svg');
  }),
  ramadan: dynamic(function () {
    cov_1bf3wwzwf().f[8]++;
    cov_1bf3wwzwf().s[11]++;
    return import('./assets/ramadan.svg');
  }),
  riyal: dynamic(function () {
    cov_1bf3wwzwf().f[9]++;
    cov_1bf3wwzwf().s[12]++;
    return import('./assets/riyal.svg');
  }),
  dirham: dynamic(function () {
    cov_1bf3wwzwf().f[10]++;
    cov_1bf3wwzwf().s[13]++;
    return import('./assets/dirham.svg');
  }),
  card: dynamic(function () {
    cov_1bf3wwzwf().f[11]++;
    cov_1bf3wwzwf().s[14]++;
    return import('./assets/card.svg');
  }),
  moon: dynamic(function () {
    cov_1bf3wwzwf().f[12]++;
    cov_1bf3wwzwf().s[15]++;
    return import('./assets/moon.svg');
  }),
  protection: dynamic(function () {
    cov_1bf3wwzwf().f[13]++;
    cov_1bf3wwzwf().s[16]++;
    return import('./assets/protection.svg');
  }),
  lightning: dynamic(function () {
    cov_1bf3wwzwf().f[14]++;
    cov_1bf3wwzwf().s[17]++;
    return import('./assets/lightning.svg');
  }),
  asterisks: dynamic(function () {
    cov_1bf3wwzwf().f[15]++;
    cov_1bf3wwzwf().s[18]++;
    return import('./assets/asterisks.svg');
  }),
  deal: dynamic(function () {
    cov_1bf3wwzwf().f[16]++;
    cov_1bf3wwzwf().s[19]++;
    return import('./assets/deal.svg');
  }),
  arrow: dynamic(function () {
    cov_1bf3wwzwf().f[17]++;
    cov_1bf3wwzwf().s[20]++;
    return import('./assets/arrow.svg');
  })
});
cov_1bf3wwzwf().s[21]++;
export var Icon = function Icon(_ref2) {
  var name = _ref2.name,
    svgAttributes = _ref2.svgAttributes;
  cov_1bf3wwzwf().f[18]++;
  var IconComponent = (cov_1bf3wwzwf().s[22]++, ICONS[name]);
  cov_1bf3wwzwf().s[23]++;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(IconComponent, svgAttributes));
};